import React, { useState, useEffect } from 'react';
import DistrictServices from '../services/DistrictServices';
import CityStatus from './TogelButton/CityStatus';
import Modal from 'react-modal';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { FaRegEye } from "react-icons/fa";
import { Tooltip } from 'react-tooltip'
Modal.setAppElement('#root');

function Cities() {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const stateId = searchParams.get('id');
  const [citiesData, setCitiesData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [canGoBack, setCanGoBack] = useState(false);
  const [isCityView, setIsCityView] = useState(false);


  useEffect(() => {
    setCanGoBack(window.history.length > 1);
    const pathSegments = location.pathname.split("/");
    setIsCityView(pathSegments.includes("city"));
  }, [location.pathname]);

  const fetchCities = async () => {
    try {
      setIsLoading(true);
      const response = await DistrictServices.getCities(stateId);
      setCitiesData(response?.data || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (stateId) {
      fetchCities();
    }
  }, [stateId]);

  const filteredData = citiesData.filter(city =>
    city.name.toLowerCase().includes(searchQuery.toLowerCase())
  );


  const handleViewPincode = (id) => {
    if (id) {
      window.location.href = `/Pincode?id=${id}`;
    }
  };

  return (
    <>
      <div className="right_col" role="main">
        <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

          <div className="my-auto">

            <h5 className="page-title fs-21 mb-1">  City List <span className="badge bg-orange">{filteredData?.length || 0}</span></h5>
            <nav>

              <ol className="breadcrumb mb-0">

                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Description
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center">

            <div className="pe-1 mb-xl-0">

              <div className="sub-title-box-right d-flex">

                 <Link className="round-add-btn" to={`/add-city?stateId=${stateId}`}>
                              <img src="img/plus.svg" alt="Add Cities" />
                 </Link>

                 
                {canGoBack && (
                  <button className="btn btn-secondary me-2" onClick={() => navigate(-1)}>
                    Back
                  </button>
                )}
                <button className="btn refreshbutton me-2" onClick={() => window.location.reload()}>
                  Refresh
                </button>
              </div>
            </div>



          </div>
        </div>

        <div className="container-box px-0 pt-2">
          <div className="Tablesearch_design">
            <div className="row">
              <div className='col-md-6'>
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <input
                    type="search"
                    name="search"
                    placeholder="Search"
                    className='form-control'
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <button className="search-btn">Search</button>
                </div>
              </div>
            </div>

          </div>

          <div className="container-box-inner table-reponsive-tabe">
            {isLoading ? (
              <p>Loading...</p>
            ) : error ? (
              <p>Error: {error}</p>
            ) : (
              <table id="example" className="table table-striped" style={{ width: "100%" }}>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>City NAME</th>
                    <th>Status</th>
                    <th>View Pincode</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((city, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{city?.name}</td>
                      <td className="status-toggle">
                        <CityStatus city={city} page="Cities" onSuccess={fetchCities} />
                      </td>


                      <td
                        onClick={() => handleViewPincode(city._id)}
                        className="view-cities-button"
                        data-tooltip-id="view-cities-tooltip"
                        data-tooltip-content=" View Pincode"
                      >
                        <FaRegEye className="custom-icon" />
                        <Tooltip id="view-cities-tooltip" />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Cities;
